<div class="mx-auto max-w-(--breakpoint-2xl)">
  @if (templatesPage) {
    <app-data-table
      (route)="this.handleRoute($event)"
      [title]="'Event Templates'"
      [dataPage]="templatesPage"
      [columns]="tableColumns"
      [rowRouterLinkTemplate]="'/event-templates/:id'"
      [rowActions]="rowActions">
      <div header class="flex flex-row w-full items-center justify-between gap-3">
<!--        <app-text-input [control]="searchControl" [placeholder]="'Search templates'"></app-text-input>-->
        <!-- VG-380: Add Template should be admin-only -->
        @if (isAdmin) {
          <a routerLink="/event-templates/new"
             class="h-12 text-theme-sm shadow-theme-xs inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2.5 font-medium
            text-gray-700 hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200">
            <lucide-icon [name]="PlusIcon"></lucide-icon>
            Add Template
          </a>
        } @else {
          <button
            class="h-12 text-theme-sm shadow-theme-xs inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-gray-50 px-4 py-2.5 font-medium text-gray-400 cursor-not-allowed"
            disabled
            title="Only admins can create templates">
            <lucide-icon [name]="PlusIcon"></lucide-icon>
            Add Template
          </button>
        }
      </div>
    </app-data-table>
  }
</div>
